module.exports = "./img/4d24eebc8325f193878722ec2a3a8cf7.png";